// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xCAWH","content":"styles_content__1huLV"};